import { Box, TextField, Typography } from "@mui/material";
import { ChangeEvent } from "react";

interface Props {
  handleChangeInput: (e: ChangeEvent<HTMLInputElement>) => void;
  name: string;
  value: string;
  error?: boolean | string;
}

export default function PriceInput(props: Props) {
  const { handleChangeInput, name, value } = props;
  return (
    <Box
      sx={{
        borderRadius: "10px",
        borderColor: "info.main",
        borderWidth: "1px",
        borderStyle: "solid",
        backgroundColor: "info.light",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <TextField
        type="text"
        name={name}
        value={value}
        onChange={handleChangeInput}
        placeholder="-----"
        inputProps={{ inputMode: "numeric", pattern: "[1-9]*" }}
        sx={{
          textAlign: "left",
          direction: "ltr",
          flex: 1,
          "& .MuiOutlinedInput-notchedOutline": {
            border: "none !important",
            outline: "none !important",
          },
          "& .MuiInputBase-input": {
            //   border: "none !important",
            outline: "none !important",
          },
          "& .MuiInputBase-root": {
            border: "none !important",
            outline: "none !important",
          },
          border: "none",
        }}
      />
      <Typography width={"45%"}>ریال</Typography>
    </Box>
  );
}
